import { useEffect, useRef } from "react";
import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";

import ButtonRoundIcon from "components/buttons/ButtonRoundIcon";

import leftIcon from "assets/img/icons/left-arrow.svg";
import rightIcon from "assets/img/icons/right-arrow.svg";
import leftWhiteIcon from "assets/img/icons/left-arrow-white.svg";
import rightWhiteIcon from "assets/img/icons/right-arrow-white.svg";
import PageListPageContainer from "./PageListPageContainer";

const PageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

const Pagination = styled.div`
  width: 100%;
  margin-top: ${css.VERTICAL_BOX_MARGIN};

  display: flex;
  justify-content: center;
  gap: ${css.BUTTONS_GAP_SMALL};

  @media (max-width: ${globalConstants.switchTablet}) {
    margin-top: 6px;
    margin-bottom: ${css.VERTICAL_BOX_MARGIN};
  }
`;

export default ({ data, limit, page, paginate, refetch }) => {
  const numOfResults = data.pageListData.numOfResults;

  const list = data.pageListData.pages.map((page) => {
    const { id, code, name, list, redirect_link } = page;

    return (
      <PageListPageContainer
        id={id}
        code={code}
        name={name}
        list={list}
        redirectLink={redirect_link}
        pageLists={data.pageListData.pageLists}
        refetch={refetch}
      />
    );
  });

  // prepare pagination
  let showPagination = false;

  if (numOfResults > limit) showPagination = true;

  const maxPage = Math.ceil(numOfResults / limit);

  return (
    <PageList>
      {list}
      {showPagination && (
        <Pagination>
          {page > 1 && (
            <ButtonRoundIcon
              icon={leftIcon}
              hoverIcon={leftWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("previous")}
            />
          )}
          {page < maxPage && (
            <ButtonRoundIcon
              icon={rightIcon}
              hoverIcon={rightWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("next")}
            />
          )}
        </Pagination>
      )}
    </PageList>
  );
};
